module.exports = __webpack_public_path__ + "img/katarina_amenities_10.28910560.jpg";